$(document).ready(function () {
  $(".tabbed-btns li").on("click", function (e) {
    e.preventDefault();

    $(".tabbed-btns li").removeClass("active-tab-btn");
    $(this).addClass("active-tab-btn");

    var target = $(this).find("a").data("url");
    $(".tab-content").hide();
    $('.tab-content[data-url-target="' + target + '"]').show();
  });

  // Trigger click on first visible tab by default
  $(".tabbed-btns li:visible:first").trigger("click");
});

$(document).ready(function () {
  // Add click event to elements with class "acr-btn"
  $(".acr-btn").on("click", function () {
    // Toggle the new class on the parent element with class "acr-item"
    $(this).parent(".acr-item").toggleClass("ac-acr-item");

    // Toggle the visibility of the associated content
    $(this).next(".acr-content").slideToggle();

    // Hide content and remove class from other items
    $(".acr-btn").not(this).next(".acr-content").slideUp();
    $(".acr-item").not($(this).parent(".acr-item")).removeClass("ac-acr-item");
  });
  //     $('.acr-item:first-child .acr-content').slideDown();
  // $('.acr-item:first-child').addClass('ac-acr-item');
});
